   /*==========================================================================================================
     FILTERS
     ==========================================================================================================*/

   angular
     .module('vppApp')
     .filter("sortBy", function () {
       return function (input, value) {
         var result = [];
         for (var x = 0; x < value.length; x++) {
           for (var i = 0; i < input.length; i++) {
             if (input[i]) {
               if (input[i].toLowerCase().indexOf(value[x].toLowerCase()) > -1) {
                 result.push(input[i]);
               }
             }

           }
         }
         return result;
       };
     });